
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Pagination } from 'element-react';

import Http from '../../networkReq/http'
import NoDataList from 'components/NoDataList'

require("./index.scss");
class PagingContent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            msg: '子组件传值给父组件',
            data: [],
            currentPage: 1,
            params: this.props.params ? this.props.params : '',
            pageSizes: this.props.pageSizes || [10, 20, 30, 40, 50, 100],
            pageSize: this.props.params && this.props.params.size ? this.props.params.size : 10
        };

    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.params != this.state.params) {
            this.setState({
                params: nextProps.params
            }, () => this.getDynamicData(1))
        }
    }
    componentDidMount() {
        this.getDynamicData(1);
    }
    getDynamicData(current) {
        let { pageSize } = this.state;
        let params = {};

        if (this.state.params) {
            params = {
                ...this.state.params
            }
        }
        params.size = pageSize;
        params.current = current;
        console.log("分页的params:", params);
        Http.get(this.props.requestUrl, params, obj => {
            if (obj && obj.code == 200) {
                const data = obj.data;
                this.setState({
                    data: data,
                    currentPage: current
                });
            }
        })

    }
    onCurrentChange(currentPage) {
        this.getDynamicData(currentPage);

    }
    onSizeChange(currentSize) {
        this.setState({ pageSize: currentSize }, () => { this.getDynamicData(1); })
    }

    render() {
        let { renderList } = this.props;
        let { data, pageSize, pageSizes } = this.state;
        return (
            <div>
                {renderList && renderList(data)}
                {data.total && data.total > 0 ?
                    <div className="pagination_bottom" style={{ textAlign: 'center' }}>
                        <Pagination layout="total, sizes, prev, pager, next, jumper" total={data.total} pageSize={pageSize} currentPage={data.currentPage}
                            pageSizes={pageSizes}
                            onCurrentChange={(val) => this.onCurrentChange(val)}
                            onSizeChange={(val) => this.onSizeChange(val)}
                        />
                    </div>
                    : <NoDataList />
                }

            </div>
        )
    }
}

export default PagingContent;